import React, { useEffect, useRef, useState } from 'react';
import storage from 'utils/storage';
import { VerificationCodeInputField } from 'components/Form';
import { Button, Spinner } from 'components/Elements';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { smsOTPSetup } from '../api/smsOTPSetup';
import { verifySMSOTPLogin } from '../api/smsOTPLogin_verify';

export const SMSOTPSetupForm = () => {
  const [verificationCode, setVerificationCode] = useState(new Array(6).fill(''));
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [success, setSuccess] = useState(false);

  const hasSentOTP = useRef(false); // <-- This prevents double calls
  const phone_number = Cookies.get('phone_number')
  const navigate = useNavigate();

  useEffect(() => {
    const sendSMSOTP = async () => {
      if (hasSentOTP.current) return; // Prevent repeated sending
      hasSentOTP.current = true;

      try {
        setLoading(true);
        await smsOTPSetup({ phoneNumber: phone_number });
      } catch (err) {
        setError('Failed to send SMS verification code. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    sendSMSOTP();
  }, []);

  const handleVerify = async () => {
    setVerifying(true);
    setError('');

    const fcmToken = storage.getFCMToken();


    try {
      await verifySMSOTPLogin({ code: verificationCode, fcmToken });
      setSuccess(true);
      Cookies.remove('authentication_level_email');
      Cookies.remove('authentication_level_password');
      Cookies.remove('authentication_level_google_auth');
      navigate('/auth/login');
    } catch (err) {
      console.error(err);
      setError('Invalid verification code. Please try again.');
    } finally {
      setVerifying(false);
    }
  };

  const handleRefresh = async () => {
    setLoading(true);
    setError('');
    try {
      await setUpSMSOTP({ phoneNumber: phone_number }); // Ensure phone number is sent
      setSuccess(false);
    } catch (err) {
      setError('Failed to send SMS verification code. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <div className="mt-4">
            <label className="block text-sm font-medium text-gray-100 mb-2 w-96">
              A 6-digit code has been sent to your phone number. Please enter it below to complete
              SMS-based two-factor authentication setup.
            </label>
            <div className="flex space-x-2 justify-start">
              <VerificationCodeInputField
                length={6}
                onChange={(code) => setVerificationCode(code)}
              />
            </div>
          </div>
          {success && <p className="text-green-500 text-center mt-3">Verification successful!</p>}
          {error && <p className="text-red-500 text-center mt-3">{error}</p>}
          <Button
            onClick={handleVerify}
            disabled={verifying || verificationCode.length === 0}
            variant="glass"
            className="mt-4 w-full"
          >
            {verifying ? 'Verifying...' : 'Verify'}
          </Button>
          <Button
            onClick={handleRefresh}
            className="mt-4 w-full"
            variant="darkGlass"
          >
            Resend OTP
          </Button>
        </>
      )}
    </div>
  );
};
